// eslint-disable-next-line import/prefer-default-export
export class Selector {
  constructor(selectEl, {
    selectorTplSel,
    selectorWrapperSel,
    selectorTogglerSel,
    selectorTitleSel,
    selectorListClass,
    selectorOptionClass,
    selectorClassAvtive,
  }) {
    this._selector = null;
    this._selectEl = selectEl;
    this._selectHolder = selectEl.parentNode;
    this._optionsArr = Array.from(this._selectEl.querySelectorAll('option'));
    this._selectorTpl = document.querySelector(selectorTplSel).content;
    this._selectorWrapperSel = selectorWrapperSel;
    this._selectorWrapper = this._selectorTpl.querySelector(selectorWrapperSel);
    this._selectorTogglerSel = selectorTogglerSel;
    this._selectorTitleSel = selectorTitleSel;
    this._selectorListClass = selectorListClass;
    this._selectorOptionClass = selectorOptionClass;
    this._selectorClassAvtive = selectorClassAvtive;
  }

  _createEl(className, textContent = null) {
    const el = document.createElement('div');
    el.classList.add(className);
    if(textContent) {
      el.textContent = textContent;
    }
    return el;
  }

  _setEventListeners(option, selectorOption, selectorTitle) {
    selectorOption.addEventListener('click', () => {
      option.selected = true;
      this._selectEl.value = option.value;
      this._selectEl.dispatchEvent(new Event('change'));
      selectorTitle.textContent = option.textContent;
    });
  }

  _toggleOptions(toggler, selector) {
    toggler.addEventListener('click', () => {
      selector.classList.toggle(this._selectorClassAvtive);
    });
    document.addEventListener('click', e => {
      if(!e.target.closest(this._selectorWrapperSel)) {
        selector.classList.remove(this._selectorClassAvtive);
      }
    });
  }

  _hideOptions(toggler, selector) {
    toggler.addEventListener('click', () => {
      selector.classList.remove(this._selectorClassAvtive);
    });
  }

  init() {
    this._selectEl.style.display = 'none';
    this._selector = this._selectorWrapper.cloneNode(true);
    const selectorToggler = this._selector.querySelector(this._selectorTogglerSel);
    const selectorTitle = this._selector.querySelector(this._selectorTitleSel);
    const selectorList = this._createEl(this._selectorListClass);

    this._optionsArr.forEach((item, index, arr) => {
      const selectedOption = arr.find(el => el.selected);
      const selectorOption = this._createEl(this._selectorOptionClass, item.textContent);
      selectorList.append(selectorOption);
      selectorTitle.textContent = selectedOption.textContent;
      this._hideOptions(selectorOption, this._selector);
      this._setEventListeners(item, selectorOption, selectorTitle);
    });
    this._selector.append(selectorList);
    this._selectHolder.prepend(this._selector);
    this._toggleOptions(selectorToggler, this._selector);
  }
}
